import React from 'react';

import useSectionIntroductionTextModal from '@HOOKS/store/modals/useSectionIntroductionTextModal';
import { useUpdateSection } from '@SERVICES';

import IntroductionTextModal from '@MODALS/IntroductionTextModal';

function SectionIntroductionTextModal() {
    const {
        state: { data: modalParams, isOpen },
        actions: sectionIntroductionTextModalActions,
    } = useSectionIntroductionTextModal(() => true);

    const [
        updateSection,
        {
            isLoading: isSaving,
            isSuccess: isSaveSuccess,
            isError: isSaveError,
        },
    ] = useUpdateSection();

    if (!modalParams) return null;

    const { sectionData, canEditDocument } = modalParams;

    const handleSave = (content: string) => {
        updateSection({
            id: sectionData.id,
            chapterId: sectionData.chapter.id,
            documentId: sectionData.document.id,
            name: sectionData.name,
            body: content,
            isMandatory: sectionData.isMandatory,
            isPageBreak: sectionData.isPageBreak,
            isLandscape: sectionData.isLandscape,
        });
    };

    const handleClose = () => {
        sectionIntroductionTextModalActions.close();
    };

    const config = {
        title: 'Section Base Text',
        subtitle: 'Base text appears first in every generated document for this section. Variants below are added only when their specific conditions are met.',
        successMessage: 'Section base text saved successfully',
        errorMessage: 'Failed to save section base text',
    };

    return (
        <IntroductionTextModal
            isOpen={isOpen}
            onClose={handleClose}
            initialValue={sectionData.baseText.body || ''}
            canEdit={canEditDocument}
            config={config}
            onSave={handleSave}
            isSaving={isSaving}
            saveError={isSaveError}
            saveSuccess={isSaveSuccess}
        />
    );
}

export default SectionIntroductionTextModal; 